import { render, staticRenderFns } from "./manage-inventory.vue?vue&type=template&id=156663b6&scoped=true"
import script from "./manage-inventory.vue?vue&type=script&lang=js"
export * from "./manage-inventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156663b6",
  null
  
)

export default component.exports